module.exports = __webpack_public_path__ + "static/media/2.f8c6d898.png";